import SurveyRequestTable from '../components/SurveyTable';
import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import Copyright from '../components/Copyright';
import theme from '../components/theme';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { getDatabase, ref, get } from 'firebase/database';
import { getAuth } from "firebase/auth";
import Hidden from '@mui/material/Hidden';

function RequestSurveys() {
  const [loading, setLoading] = useState(false);
  const [polling, setPolling] = useState(false);
  const [error, setError] = useState('');
  const hasRun = useRef(false);
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const transactionId = params.get("transactionId");

    if (transactionId) {
      setLoading(true);
      setPolling(true);
    }

    if (transactionId && !hasRun.current) {
      const db = getDatabase();
      const refBudget = ref(db, `SurveyBudget/${auth.currentUser.uid}`);

      let checkCount = 0;
      const maxChecks = 7;

      const timer = setInterval(() => {
        get(refBudget).then((snapshot) => {
          const budgetData = snapshot.val();
          const lastTransactionId = budgetData ? budgetData.lastTransactionId : null;
          const lastPaymentIntentStatus = budgetData ? budgetData.lastPaymentIntent : null;

          if (lastTransactionId === transactionId && lastPaymentIntentStatus === "succeeded") {
            setLoading(false);
            setPolling(false);
            navigate('.', { replace: true, search: '' }); // remove URL parameters
            window.location.reload();
            clearInterval(timer); // Stop polling once the transaction ID matches and succeeds
          } else if (lastTransactionId === transactionId && lastPaymentIntentStatus !== "succeeded") {
            setLoading(false);
            setPolling(false);
            clearInterval(timer); // Stop polling once the transaction ID matches but failed
            navigate('.', { replace: true, search: '' }); // remove URL parameters
            window.location.reload();
            setError('The latest transaction failed. Your payment method may be invalid or there may have been a technical issue.');
          }

          checkCount++;
          if (checkCount >= maxChecks) {
            setLoading(false);
            setPolling(false);
            clearInterval(timer); // Stop polling after max attempts
            navigate('.', { replace: true, search: '' }); // remove URL parameters
            window.location.reload();
            setError('The latest transaction failed. Your payment method may be invalid or there may have been a technical issue.');
          }
        }).catch(err => {
          setLoading(false);
          setPolling(false);
          clearInterval(timer); // Stop polling on error
          navigate('.', { replace: true, search: '' }); // remove URL parameters
          window.location.reload();
          setError('Error fetching transaction status. Please try again later.');
        });
      }, 5000); // Poll every 5 seconds

      hasRun.current = true;
      return () => clearInterval(timer); // cleanup on unmount
    }
  }, [auth, navigate]);

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Hidden xsUp={!loading}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh', // full viewport height
            }}
          >
            <CircularProgress color="success" m={10} />
          </Box>
        </Hidden>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            pointerEvents: polling ? 'none' : 'auto', // Disable interaction while polling
            opacity: polling ? 0.5 : 1, // Dim the content while polling
          }}
        >
          {error && (
            <Alert severity="error" onClose={() => setError('')}>
              {error}
            </Alert>
          )}
          <Avatar sx={{ m: 1, bgcolor: 'analogous.main' }}>
            <RequestPageIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
          Assessments Request Form
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center">
            Here you can fill out the data for candidates and send assessments.
          </Typography>
          <SurveyRequestTable />
        </Box>
        <br></br>
        <br></br>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}

export default RequestSurveys;